import { Search } from 'lucide-react'
import { DefaultSheet, DefaultTooltip, Col, Row, FormGroup, Label, SheetBody } from 'twyne-new.ui'

import { getInfo } from '@Components/Grid/components/Table/formatters';
import { Value } from '@Components/modals/ObjectModal';

export default function DetailsEntity({ info }) {
  const { row } = getInfo(info)
  const data = parseObjectModalData({ ...row })

  return <DefaultSheet
    trigger={<DefaultTooltip content='Details' side='left'> <Search size={16} /> </DefaultTooltip>}
    title='Error Details'
  >
    <SheetBody>
      <Row>
        {data.map(([key, value], index) => <>
          <Col size={key === 'stack' ? '12' : '6'} key={index}>
            <FormGroup>
              <Label className='twy-text-base-accent'>{key}</Label><br />
              <Value value={value} key={key} />
            </FormGroup>
          </Col>
        </>)}
      </Row>
    </SheetBody>
  </DefaultSheet>
}

const parseObjectModalData = row => {
  const error = {
    ...row,
    errorDetails: {
      ...row.errorDetails,
    },
  }
  error.errorDetails.stack = {
    stack: error.errorDetails.stack,
  }
  delete error.errorDetails.image

  const data = Object.entries(error.errorDetails)
  delete error.errorDetails

  data.push(...Object.entries(error))

  return data
}
